export default "__VITE_ASSET__DD5uMFVr__"